
import ReactGA from 'react-ga4';
import TrackingProvider from './tracking-provider';
import { logIt } from '@/services/logger';

class GoogleAnalyticsProvider extends TrackingProvider {
  constructor(config) {
    super(config);
    this.name = 'GoogleAnalytics';
  }

  init() {
    if (this.config.trackingId) {
      ReactGA.initialize(this.config.trackingId);
      logIt("log", `[${this.name}] Initialized with ID: ${this.config.trackingId}`);
    } else {
      logIt("Error", `[${this.name}] Tracking ID not provided.`);
    }
  }

  track(eventName, properties = {}) {
    logIt("log", `[${this.name}] Track Event: ${eventName}`, properties);
    
    ReactGA.event(eventName, properties);
  }

  identify(userId, traits = {}) {
    logIt("log", `[${this.name}] Identify User: ${userId}`, traits);
    
    // GA4 User ID
    ReactGA.set({ user_id: userId });
    
    // User properties
    if (Object.keys(traits).length > 0) {
        ReactGA.gtag("set", "user_properties", traits);
    }
  }

  page(path, properties = {}) {
    logIt("log", `[${this.name}] Page View: ${path}`, properties);
    
    ReactGA.send({ hitType: 'pageview', page: path, ...properties });
  }
}

export default GoogleAnalyticsProvider;
